module.exports = __webpack_public_path__ + "img/trackicon.f6c9f152.svg";